/** Static copy from docs/AFS + audit program.xlsm — sheet Ai_T */

export type AiIndexKind = 'letter' | 'appendix';

export interface AiIndexEntry {
    code: string;
    kind: AiIndexKind;
    title: string;
    /** When true, row is always shown (program sections, not BS/PL driven). */
    alwaysVisible?: boolean;
    /** When true, row is never shown. */
    neverVisible?: boolean;
}

/** A–Z audit file index (Excel Ai_T rows 5–30). */
export const AI_INDEX_ENTRIES: AiIndexEntry[] = [
    {code: 'A', kind: 'letter', title: 'FINAL COMPLETION', alwaysVisible: true},
    {code: 'B', kind: 'letter', title: 'AUDIT COMPLETION', alwaysVisible: true},
    {code: 'C', kind: 'letter', title: 'AUDIT PLANNING', alwaysVisible: true},
    {code: 'D', kind: 'letter', title: 'OPTIONAL PROGRAMMES', alwaysVisible: true},
    {code: 'E', kind: 'letter', title: 'INTANGIBLE ASSETS'},
    {code: 'F', kind: 'letter', title: 'PROPERTY, PLANT AND EQUIPMENT'},
    {code: 'G', kind: 'letter', title: 'INVESTMENTS IN GROUP AND ASSOCIATED UNDERTAKINGS'},
    {code: 'H', kind: 'letter', title: 'OTHER INVESTMENTS'},
    {code: 'I', kind: 'letter', title: 'INVENTORIES'},
    {code: 'J', kind: 'letter', title: 'TRADE & OTHER RECEIVABLES'},
    {code: 'K', kind: 'letter', title: 'BANK BALANCES AND CASH'},
    {code: 'L', kind: 'letter', title: 'TRADE & OTHER PAYABLES'},
    {code: 'M', kind: 'letter', title: 'LONG-TERM LOANS AND DEFERRED INCOME'},
    {code: 'N', kind: 'letter', title: 'PROVISIONS, CONTINGENT LIABILITIES AND FINANCIAL COMMITMENTS', alwaysVisible: true},
    {code: 'O', kind: 'letter', title: 'SHARE CAPITAL, RESERVES AND STATUTORY RECORDS'},
    {code: 'P', kind: 'letter', title: 'INCOME TAXES'},
    {code: 'Q', kind: 'letter', title: 'INCOME AND EXPENDITURE – ANALYSES FOR TAX PURPOSES'},
    {code: 'R', kind: 'letter', title: 'PROFIT AND LOSS'},
    {code: 'S', kind: 'letter', title: 'OPERATING EFFECTIVENESS OF CONTROLS', alwaysVisible: true},
    {code: 'T', kind: 'letter', title: 'SUBSEQUENT EVENTS', alwaysVisible: true},
    {code: 'U', kind: 'letter', title: 'NOT USED', neverVisible: true},
    {code: 'V', kind: 'letter', title: 'GENERAL LEDGER', alwaysVisible: true},
    {code: 'W', kind: 'letter', title: 'CONSOLIDATION', alwaysVisible: true},
    {code: 'X', kind: 'letter', title: 'ACCOUNTS WORKING PAPERS', alwaysVisible: true},
    {code: 'Y', kind: 'letter', title: 'OTHER PRIMARY FINANCIAL STATEMENTS', alwaysVisible: true},
    {code: 'Z', kind: 'letter', title: 'COMPUTER REPORTS AND RECORDS RECEIVED', alwaysVisible: true},
    {code: 'PAF', kind: 'letter', title: 'PERMANENT AUDIT FILE', alwaysVisible: true},
];

export const AI_APPENDIX_ENTRIES: AiIndexEntry[] = [
    {code: '1', kind: 'appendix', title: 'BUSINESS COMBINATIONS', alwaysVisible: true},
    {code: '2', kind: 'appendix', title: 'INVESTMENT PROPERTIES', alwaysVisible: true},
    {code: '3', kind: 'appendix', title: 'OTHER FINANCIAL INSTRUMENTS AND DERIVATIVES', alwaysVisible: true},
    /** No programme sheets in APM 2024 Edition — keep listed but inactive unless FS has AP4. */
    {code: '4', kind: 'appendix', title: 'CONSTRUCTION CONTRACTS'},
    {code: '5', kind: 'appendix', title: 'REVENUE UNDER HKFRS 15', alwaysVisible: true},
    {code: '6', kind: 'appendix', title: 'LEASES UNDER HKFRS 16', alwaysVisible: true},
];

/** Index letters driven by Balance Sheet lines only (ignore PL schedules with same letter). */
export const BS_DRIVEN_INDEX_LETTERS = new Set(['E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P']);

/** Index letters driven by Profit & Loss lines only. */
export const PL_DRIVEN_INDEX_LETTERS = new Set(['Q', 'R']);

/** BS/PL-driven index letters (E–R). */
export const BS_PL_INDEX_LETTERS = new Set([...BS_DRIVEN_INDEX_LETTERS, ...PL_DRIVEN_INDEX_LETTERS]);
